module.exports = __webpack_public_path__ + "img/button_join.67c8ad34.png";